<template>
  <el-container  style="display: block;background-color: #000;margin-left: 6%;overflow: hidden;">
	<div style="position: absolute;right: 1%;bottom: 0;color: #fff;font-size: 30px;border: #c63636 solid 5px;letter-spacing: 10px;padding: 10px;">
		<a href="https://data3.yoooooo.com/uploads/亦真宇宙-宇宙产品群-亦真宇宙团队指引文档(20250122).xlsx" style="color: #fff;text-decoration: none;">
			<div>说明</div>
			<div>文档</div>
		</a>
	</div>  
    <el-row  class="tui-el" style="margin-top: 20px;">
      <el-col  :style="{'width':screenWidth*0.35+'px'}">
		  <el-row style="color: #fff;font-size: 28px;margin-bottom: 20px;font-weight: bold;">
			 能力 
		  </el-row>
		  <el-row style="color: #fff;font-size: 24px;margin-bottom: 20px;">
		  		<el-col :span="18">
					<input placeholder="搜索能力名称" v-model="searchName" class="search_input"  />
				</el-col>
				<el-col :span="6">
					
					<div class="search" @click="loadData()" style="">搜索</div>
				</el-col>
		  </el-row>
		  <el-row style="height: 100%;">
		  	<ul class="nengli"  :style="{'height':screenHeight*0.7+'px'}">
				<li class="nengli_li" :class="{'nengli_li_c':clid == item['value']}" @click="chose(item['value'])" v-for="(item,index) in options" style="position: relative;" @mousemove="slid=item['value']" @mouseout="slid=0">
					<div>{{item['label']}}</div>
					<div v-show="slid == item['value']" class="nengli_beizhu" style="">解释：{{item['beizhu']}}</div>
				</li>
			</ul>		  
		  </el-row>
	  </el-col>
	  
	  
	  
      <el-col  style="margin-left: 5%;margin-right: 2px;" :style="{'width':screenWidth*0.35+'px'}">
      	<el-row style="color: #fff;font-size: 24px;margin-bottom: 20px;">
      	    <button class="fc" :class="{'fcc':cfc == 'W'}" @click="chosef('W')">W</button>
			<button class="fc" :class="{'fcc':cfc == 'A'}" @click="chosef('A')">A</button>
			<button class="fc" :class="{'fcc':cfc == 'X'}" @click="chosef('X')">X</button>
      	</el-row>
      	<el-row style="color: #fff;font-size: 24px;margin-bottom: 20px;">
      		<el-col :span="18">
      			<input placeholder="输入词内容" v-model="newName" class="search_input"  />
      		</el-col>
      		<el-col :span="6">      					
      			<div class="search" @click="add()" style="">添加</div>
      		</el-col>
      	</el-row>
      	<el-row style="height: 100%;">
			<ul class="nengli"  :style="{'height':screenHeight*0.7+'px'}">
				<li class="nengli_li_ci">
					<el-col :span="18" class="nengli_li_ci_c">
						词({{cfc}})
					</el-col>
					<el-col :span="6" class="nengli_li_ci_c">      					
						操作
					</el-col>
				</li>
				<li class="nengli_li_ci"  v-for="(item,index) in list">
					<el-col :span="18" class="nengli_li_ci_t">
						{{item['name']}}
					</el-col>
					<el-col :span="6" class="nengli_li_ci_c">      					
						<div  @click="del(item['id'])">删除</div>
					</el-col>
				</li>
			</ul>	
			<div class="page">
				<el-pagination
				  @size-change="loadList()"
				  @current-change="loadList()"
				  :current-page.sync="page"
				  :page-size="15"
				  background
				  layout="total,prev, pager, next, jumper"
				  :total="count">
				</el-pagination>
			</div>	  
      	</el-row>
      </el-col>
    </el-row>
    
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      >
      <span>确认删除？</span>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="dialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="doDell()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisibleci"
      width="30%"
      >
      <span>确认删除该组？</span>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="dialogVisibleci = false">取 消</el-button>
    	<el-button type="primary" @click="dociDell()">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>

  export default {
    data() {
       return {
			count:0,
			options: [],
			types:[{'id':0,'name':'无'},{'id':1,'name':'左'},{'id':2,'name':'右'},{'id':3,'name':'左右'}],
			delId:'',
			delIndex:'',
			dialogVisible:false,
			value: '',
			values:0,
			newName:'',
			imageId: 0,
			list: [],
			search:'',
			page:1,
			ciku:'',
			listci:[],
			dialogVisibleci:false,
			cilid:0,
			ciname:'',
			screenWidth : window.innerWidth,
			screenHeight : window.innerHeight,
			searchName:'',
			clid:35,
			slid:0,
			cfc:'W',
			loadUrl:'http://z21p.yoooooo.com/index.php/index/dataf/tiaoListw',
			addUrl:'http://z21p.yoooooo.com/index.php/index/dataf/pythontiaoListAddw',
			delUrl:'http://z21p.yoooooo.com/index.php/index/dataf/pythontiaoListDelw'


      }
    },
	directives: {
    },
    created() {
       
      this.loadData();
    },

	methods:{
		chosef(f){
			this.cfc = f
			if(f == 'W'){
				this.loadUrl='http://z21p.yoooooo.com/index.php/index/dataf/tiaoListw'
				this.addUrl='http://z21p.yoooooo.com/index.php/index/dataf/pythontiaoListAddw'
				this.delUrl='http://z21p.yoooooo.com/index.php/index/dataf/pythontiaoListDelw'
			}
			if(f == 'A'){
				this.loadUrl='http://z21p.yoooooo.com/index.php/index/dataf/muBiaoList'
				this.addUrl='http://z21p.yoooooo.com/index.php/index/dataf/pythonMubiaoListAdd'
				this.delUrl='http://z21p.yoooooo.com/index.php/index/dataf/pythonMubiaoListDel'
			}
			if(f == 'X'){
				this.loadUrl='http://z21p.yoooooo.com/index.php/index/dataf/keyTwo'
				this.addUrl='http://z21p.yoooooo.com/index.php/index/dataf/keyAdd'
				this.delUrl='http://z21p.yoooooo.com/index.php/index/dataf/keyWuYiDel1'
			}
			this.loadList()
		},
		chose(id){
			this.clid = id
			this.loadList()
		},
		loadData(){
			const axiosInstance = this.$axios.create({
				headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
				withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
			});
			axiosInstance({
				method:'get',
				params:{
					name:this.searchName
				},
				url:'http://z21p.yoooooo.com/index.php/index/dataf/pythonImgList'
			})
			.then(res=>{
				this.options = res.data;
				this.clid = this.options[0]['value']
				this.loadList()
			
			})
			.catch(err=>{

			});
		},
		loadList(){
		  const axiosInstance = this.$axios.create({
			headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
			withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
		  });
		  axiosInstance({
			method:'get',
			params:{
			  p:this.page,
			  l_id:this.clid,
			  name:this.search
			},
			url:this.loadUrl
		  })
		  .then(res=>{
			this.list = res.data.data;
			this.count = res.data.count;

		  })
		  .catch(err=>{

		  });
		},

		ceshi(index){
		  this.imageId = index
		},
		del(id){
		  this.dialogVisible = true
		  this.delId = id
		},
		doDell(){
		  const axiosInstance = this.$axios.create({
			headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
			withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
		  });

		  if(this.delId == ''){
			 return false
		  }
		  axiosInstance({
			method:'post',
			params:{
				id:this.delId,
			},
			url:this.delUrl
		  })
		  .then(res=>{
			if(res.data.code == 200){
			   this.delId = 0
			   this.dialogVisible = false
			   this.loadList()
			   this.$message({
				type: 'success',
				message: '操作成功'
			   });
			 	
			}else{
			   this.dialogVisible = false
			}

		  })
		  .catch(err=>{

		  });
		},
		add(){
		  const axiosInstance = this.$axios.create({
			headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
			withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
		  });
		  if(this.newName == ''){
			this.msg('请填写词内容','error')
			return false
		  }

		  console.log(this.addImgs)
		  axiosInstance({
			method:'post',
			url:this.addUrl,
			params:{
				name:this.newName,
				l_id:this.clid,
				type:0
			}
		  })
		  .then(res=>{			
			this.newName = ''
			this.loadList()
		  })
		  .catch(err=>{

		  });
		},
		msg(msg,type){
			this.$message({
			  message: msg,
			  type: type
			});
		},

	}


  }
</script>

<style>
body{
	background-color: #000;
	font-family: hanyi;
}
.el-scrollbar__bar{
	overflow: hidden;
}
.nengli{
	width: 100%;
	/* height: 100%; */
	border: 1px solid #0020c1;
	overflow-y: auto;
}
.nengli_li{
	border: 1px solid #0020c1;
	color: #fff;
	height: 70px;
	display: flex;
	align-items: center;
	/* line-height: 70px; */
	font-size: 1.5rem;
}
.nengli_beizhu{
	position: absolute;
	font-size: 14px;
	bottom: 0;
	left: 2%;
	color: #ffe700;
	background-color: #5b5b5b;
	/* height: 20px; */
	/* line-height: 20px; */
	display: flex;
	align-items: center;
	opacity: 0.9;
	padding: 3px 10px;
	border-radius: 10px;
}
.nengli_li_c{
	background-color: #1b41ff;
}  
.search_input{
	width: 100%;
	height: 50px;
	background-color: #000;
	border: 1px solid #0020c1;
	font-size: 20px;
	color: #fff;
	text-indent: 10px;
}
.search{
	width: 100%;
	height: 54px;
	line-height: 54px;
	text-align: center;
	background-color: #00fffc;
	letter-spacing: 10px;
	color: #000;
	font-family: hanyi;
	font-weight: bold;
}

.nengli_li_ci{
	color: #fff;
	height: 50px;
	line-height: 50px;
	font-size: 1.5rem;
}
.nengli_li_ci_t{
	border: 1px solid #0020c1;
	color: #fff;
	height: 50px;
	line-height: 50px;
	padding-left: 15px;
	font-size: 1.2rem;
}
.nengli_li_ci_c{
	border: 1px solid #0020c1;
	color: #fff;
	height: 50px;
	line-height: 50px;
	text-align: center;
	 
}
.nengli_li_ci_c div{
	font-size: 1.2rem;
	background-color: #c63636;
	width: 40%;
	margin-left: 30%;
	height: 30px;
	line-height: 30px;
	margin-top: 8px;
	
}
.fc{
	height: 50px;
	width: 70px;
	line-height: 50px;
	font-size: 30px;
	color: #fff;
	background-color: #000;
	border: 1px solid #fff;
}
.fcc{
	 
	background-color: #1b41ff ;
	 
}
.page{
	float: right;
}
.el-pagination button{
	background-color: #1b41ff !important;
}
.el-pager .number{
	background-color: #1b41ff !important;
}
.el-pagination__total{
	color: #fff !important;
}
.el-pagination__jump{
	color: #fff !important;
}
.el-input input{
	background-color: #000 !important;
	border: 1px solid #0020c1 !important;
	color: #fff !important;
}
/* 自定义整个滚动条 */
::-webkit-scrollbar {
  
  width: 8px; /* 设置滚动条的宽度 */
}
 
/* 自定义滚动条轨道 */
::-webkit-scrollbar-track {
  background: #000; /* 设置轨道的背景颜色 */
}
 
/* 自定义滚动条的滑块（thumb） */
::-webkit-scrollbar-thumb {
  background: #00fffc; /* 设置滑块的背景颜色 */
}
 
/* 当滑块悬停或活动时自定义滚动条的滑块 */
::-webkit-scrollbar-thumb:hover {
  background: #00fffc; /* 设置滑块在悬停状态下的背景颜色 */
}
</style>



// WEBPACK FOOTER //
// src/components/main/tiaow.vue